import React from 'react';
import { Button, Modal } from 'react-bootstrap';

interface AlertDialogProps {
  title: string;
  btns?: ('accept' | 'cancel' | 'close')[];
  show: boolean;
  onClose: (wasAccepted: boolean) => void;
  icon?: 'question' | 'warning' | 'error' | 'information' | 'success' | 'share';
  subtitle?: string | JSX.Element;
  titleAlign?: 'start' | 'end' | 'left' | 'right' | 'center' | 'justify';
  titleSize?: string;
  separator?: boolean;
}

export default function AlertDialog(props: AlertDialogProps) {
  return (
    <>
      {props.show && (
        <div
          style={{
            position: 'fixed',
            width: '100%',
            height: '100%',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            backgroundColor: 'rgba(255,255,255,0.7)',
            zIndex: 9999,
          }}>
          <Modal.Dialog centered>
            {props.btns?.includes('close') && (
              <Modal.Header
                closeButton
                onHide={() => {
                  props.onClose(false);
                }}>
                <h4>Concursar</h4>
              </Modal.Header>
            )}
            <Modal.Body
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              {props.icon && IconsMap.get(props.icon)}
              <div
                style={{
                  display: 'flex',
                  width: '100%',
                  justifyContent: props.titleAlign ? props.titleAlign : 'center',
                }}>
                <h2 style={{ fontSize: props.titleSize }}>{props.title}</h2>
              </div>
              {props.separator && <hr style={{ width: '90%' }} />}
              {props.subtitle}
            </Modal.Body>
            <Modal.Footer style={{ justifyContent: 'center' }}>
              {props.btns && (
                <>
                  {props.btns.find((a) => a === 'cancel') && (
                    <Button
                      variant="secondary"
                      onClick={() => {
                        props.onClose(false);
                      }}>
                      Cancelar
                    </Button>
                  )}
                  {props.btns.find((a) => a === 'accept') && (
                    <Button
                      variant="success"
                      style={{ marginLeft: '35pt' }}
                      onClick={() => {
                        props.onClose(true);
                      }}>
                      Aceptar
                    </Button>
                  )}
                </>
              )}
            </Modal.Footer>
          </Modal.Dialog>
        </div>
      )}
    </>
  );
}

const IconsMap = new Map<string, any>([
  [
    'question',
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496.158 496.158" width={96} height={96}>
      <path
        d="M496.158 248.085C496.158 111.063 385.089.003 248.083.003 111.07.003 0 111.063 0 248.085c0 137.001 111.07 248.07 248.083 248.07 137.006 0 248.075-111.069 248.075-248.07z"
        fill="#25b7d3"></path>
      <path
        d="M138.216 173.592c0-13.915 4.467-28.015 13.403-42.297 8.933-14.282 21.973-26.11 39.111-35.486 17.139-9.373 37.134-14.062 59.985-14.062 21.238 0 39.99 3.921 56.25 11.755 16.26 7.838 28.818 18.495 37.683 31.97 8.861 13.479 13.293 28.125 13.293 43.945 0 12.452-2.527 23.367-7.581 32.739-5.054 9.376-11.062 17.469-18.018 24.279-6.959 6.812-19.446 18.275-37.463 34.388-4.981 4.542-8.975 8.535-11.975 11.976-3.004 3.443-5.239 6.592-6.702 9.447-1.466 2.857-2.603 5.713-3.406 8.57-.807 2.855-2.015 7.875-3.625 15.051-2.784 15.236-11.501 22.852-26.147 22.852-7.618 0-14.028-2.489-19.226-7.471-5.201-4.979-7.8-12.377-7.8-22.192 0-12.305 1.902-22.962 5.713-31.97 3.808-9.01 8.861-16.92 15.161-23.73 6.296-6.812 14.794-14.904 25.488-24.28 9.373-8.202 16.15-14.392 20.325-18.567a62.97 62.97 0 0010.547-13.953c2.856-5.126 4.285-10.691 4.285-16.699 0-11.718-4.36-21.605-13.074-29.663-8.717-8.054-19.961-12.085-33.728-12.085-16.116 0-27.981 4.065-35.596 12.195-7.618 8.13-14.062 20.105-19.336 35.925-4.981 16.555-14.43 24.829-28.345 24.829-8.206 0-15.127-2.891-20.764-8.679-5.639-5.786-8.458-12.048-8.458-18.787zm107.226 240.82c-8.937 0-16.737-2.895-23.401-8.68-6.667-5.784-9.998-13.877-9.998-24.279 0-9.229 3.22-16.991 9.668-23.291 6.444-6.297 14.354-9.448 23.73-9.448 9.229 0 16.991 3.151 23.291 9.448 6.296 6.3 9.448 14.062 9.448 23.291 0 10.255-3.296 18.312-9.888 24.17-6.592 5.858-14.208 8.789-22.85 8.789z"
        fill="#fff"></path>
    </svg>,
  ],
  [
    'warning',
    <svg xmlns="http://www.w3.org/2000/svg" width={96} height={96} viewBox="0 -25 511.807 511">
      <path
        d="M433.145 452.672H78.668a70.128 70.128 0 01-59.684-33.277 70.127 70.127 0 01-3.035-68.27l177.153-303.36a69.025 69.025 0 0150.003-37.632 71.805 71.805 0 0112.801-1.195 69.513 69.513 0 0162.805 38.828l177.152 303.359a70.127 70.127 0 01-3.035 68.27 70.119 70.119 0 01-59.683 33.277zm0 0"
        fill="#fec108"></path>
      <path
        d="M407.543 452.672H78.668a70.128 70.128 0 01-59.684-33.277 70.127 70.127 0 01-3.035-68.27l177.153-303.36a69.025 69.025 0 0150.003-37.632 69.024 69.024 0 0150.008 37.633l177.153 303.359a70.13 70.13 0 01-62.723 101.547zm0 0"
        fill="#ffdc00"
      />
      <path
        d="M290.04 375.871a34.117 34.117 0 01-9.993 24.14 34.137 34.137 0 01-24.14 9.997 32.107 32.107 0 01-12.802-2.563 34.03 34.03 0 010-63.145 32.107 32.107 0 0112.801-2.562 34.12 34.12 0 0134.133 34.133zm0 0M290.04 111.34v162.133a34.117 34.117 0 01-34.134 34.132 32.036 32.036 0 01-12.8-2.558 33.95 33.95 0 01-21.333-31.574V111.34a33.95 33.95 0 0121.332-31.574 32.036 32.036 0 0112.801-2.559 34.071 34.071 0 0124.149 9.984 34.071 34.071 0 019.984 24.149zm0 0"
        fill="#37474f"
      />
      <path
        d="M264.441 375.871c0-17.437-9.55-31.57-21.336-31.57-11.78 0-21.332 14.133-21.332 31.57s9.551 31.574 21.332 31.574c11.786 0 21.336-14.136 21.336-31.574zm0 0M264.441 111.34v162.133a33.948 33.948 0 01-21.336 31.574 33.95 33.95 0 01-21.332-31.574V111.34a33.95 33.95 0 0121.332-31.574 34.83 34.83 0 0111.352 7.425 34.343 34.343 0 019.984 24.149zm0 0"
        fill="#607d8b"
      />
      <path d="M433.102 461.207H78.71A78.715 78.715 0 018.313 347.285L185.77 43.43C199.238 16.945 226.477.3 256.19.402c29.715.106 56.836 16.934 70.122 43.512l176.93 302.89a78.702 78.702 0 01-3.04 76.84 78.7 78.7 0 01-67.101 37.563zM255.906 17.473a60.523 60.523 0 00-55.136 34.074L23.309 355.407a61.664 61.664 0 003.101 59.726 61.677 61.677 0 0052.3 29.008h354.392a61.643 61.643 0 0052.441-29.239 61.635 61.635 0 002.695-59.98L311.312 52.032a60.806 60.806 0 00-55.406-34.56zm0 0" />
      <path d="M255.906 418.54c-23.562 0-42.664-19.103-42.664-42.669 0-23.562 19.102-42.664 42.664-42.664 23.567 0 42.668 19.102 42.668 42.664-.027 23.555-19.113 42.64-42.668 42.668zm0-68.267c-14.136 0-25.597 11.461-25.597 25.598 0 14.14 11.46 25.602 25.597 25.602 14.14 0 25.602-11.461 25.602-25.602-.016-14.129-11.469-25.582-25.602-25.598zm0 0M255.906 316.14c-23.55-.027-42.636-19.113-42.664-42.667V111.34c0-23.567 19.102-42.668 42.664-42.668 23.567 0 42.668 19.101 42.668 42.668v162.133c-.027 23.554-19.113 42.64-42.668 42.668zm0-230.402c-14.133.016-25.582 11.469-25.597 25.602v162.133c0 14.136 11.46 25.601 25.597 25.601 14.14 0 25.602-11.465 25.602-25.601V111.34c-.016-14.133-11.469-25.586-25.602-25.602zm0 0" />
    </svg>,
  ],
  [
    'error',
    <svg viewBox="0 0 496.158 496.158" xmlns="http://www.w3.org/2000/svg" width={96} height={96}>
      <path
        d="M496.158 248.085C496.158 111.064 385.088.003 248.082.003 111.07.003 0 111.063 0 248.085c0 137.002 111.07 248.07 248.082 248.07 137.006 0 248.076-111.068 248.076-248.07z"
        fill="#e04f5f"
      />
      <path
        d="M277.042 248.082l72.528-84.196c7.91-9.182 6.876-23.041-2.31-30.951-9.172-7.904-23.032-6.876-30.947 2.306l-68.236 79.212-68.229-79.212c-7.91-9.188-21.771-10.216-30.954-2.306-9.186 7.91-10.214 21.77-2.304 30.951l72.522 84.196-72.522 84.192c-7.91 9.182-6.882 23.041 2.304 30.951a21.864 21.864 0 0014.316 5.318 21.914 21.914 0 0016.638-7.624l68.229-79.212 68.236 79.212c4.338 5.041 10.47 7.624 16.637 7.624a21.863 21.863 0 0014.311-5.318c9.186-7.91 10.22-21.77 2.31-30.951l-72.529-84.192z"
        fill="#fff"
      />
    </svg>,
  ],
  [
    'information',
    <svg viewBox="0 0 496.158 496.158" xmlns="http://www.w3.org/2000/svg" width={96} height={96}>
      <path
        d="M496.158 248.085C496.158 111.063 385.089.003 248.083.003 111.07.003 0 111.063 0 248.085c0 137.001 111.07 248.07 248.083 248.07 137.006 0 248.075-111.069 248.075-248.07z"
        fill="#25b7d3"
      />
      <g fill="#fff">
        <path d="M315.249 359.555a5.002 5.002 0 00-6.27-1.702c-24.582 11.637-52.482 23.94-57.958 25.015a4.83 4.83 0 01-.644-.737c-.742-1.005-1.103-2.318-1.103-4.015 0-13.905 10.495-56.205 31.192-125.719 17.451-58.406 19.469-70.499 19.469-74.514 0-6.198-2.373-11.435-6.865-15.146-4.267-3.519-10.229-5.302-17.719-5.302-12.459 0-26.899 4.73-44.146 14.461-16.713 9.433-35.352 25.41-55.396 47.487a5.002 5.002 0 005.591 7.992c7.037-2.872 42.402-17.359 47.557-20.597 4.221-2.646 7.875-3.989 10.861-3.989.107 0 .199.004.276.01.036.198.07.5.07.933 0 3.047-.627 6.654-1.856 10.703-30.136 97.641-44.785 157.498-44.785 182.994 0 8.998 2.501 16.242 7.432 21.528 5.025 5.393 11.803 8.127 20.146 8.127 8.891 0 19.712-3.714 33.08-11.354 12.936-7.392 32.68-23.653 60.363-49.717a4.998 4.998 0 00.705-6.458zM314.282 76.672c-4.925-5.041-11.227-7.597-18.729-7.597-9.34 0-17.475 3.691-24.176 10.971-6.594 7.16-9.938 15.946-9.938 26.113 0 8.033 2.463 14.69 7.32 19.785 4.922 5.172 11.139 7.794 18.476 7.794 8.958 0 17.049-3.898 24.047-11.586 6.876-7.553 10.363-16.433 10.363-26.393.001-7.654-2.476-14.075-7.363-19.087z" />
      </g>
    </svg>,
  ],
  [
    'success',
    <svg viewBox="0 0 496.158 496.158" xmlns="http://www.w3.org/2000/svg" width={96} height={96}>
      <path
        d="M496.158 248.085C496.158 111.064 385.088.003 248.082.003 111.07.003 0 111.063 0 248.085c0 137.002 111.07 248.07 248.082 248.07 137.006 0 248.076-111.068 248.076-248.07z"
        fill="#2e7d33"
      />
      <path
        d="M384.673 164.968c-5.84-15.059-17.74-12.682-30.635-10.127-7.701 1.605-41.953 11.631-96.148 68.777-22.49 23.717-37.326 42.625-47.094 57.045-5.967-7.326-12.803-15.164-19.982-22.346-22.078-22.072-46.699-37.23-47.734-37.867-10.332-6.316-23.82-3.066-30.154 7.258-6.326 10.324-3.086 23.834 7.23 30.174.211.133 21.354 13.205 39.619 31.475 18.627 18.629 35.504 43.822 35.67 44.066a21.943 21.943 0 0022.022 9.461 21.951 21.951 0 0017.545-16.332c.053-.203 8.756-24.256 54.73-72.727 37.029-39.053 61.723-51.465 70.279-54.908.082-.014.141-.02.252-.043-.041.01.277-.137.793-.369 1.469-.551 2.256-.762 2.301-.773-.422.105-.641.131-.641.131l-.014-.076a2969.508 2969.508 0 0111.533-4.984c11.16-4.585 14.789-16.589 10.428-27.835z"
        fill="#fff"
      />
    </svg>,
  ],
  [
    'share',
    <svg viewBox="0 0 496.158 496.158" xmlns="http://www.w3.org/2000/svg" width={96} height={96}>
      <path
        d="M0 248.085C0 111.064 111.07.003 248.076.003c137.012 0 248.082 111.061 248.082 248.082 0 137.002-111.07 248.07-248.082 248.07C111.07 496.155 0 385.087 0 248.085z"
        fill="#25b7d3"
      />
      <g fill="#fff">
        <circle cx="146.489" cy="248.969" r="53.807" />
        <circle cx="310.749" cy="153.319" r="53.807" />
        <circle cx="310.749" cy="342.839" r="53.807" />
        <path d="M153.789 259.642l-14.56-25.003 164.257-95.643L318.046 164z" />
        <path d="M303.472 355.31l-164.257-95.642 14.559-25.004 164.257 95.642z" />
      </g>
    </svg>,
  ],
]);
